import { isUndefined } from "@/utils/typeGuards";
import DeviceGenreAppliedFilterChip from "./DeviceGenreAppliedFilterChip";
import DeviceGenreAvailableFilterChip from "./DeviceGenreAvailableFilterChip";
import type { DeviceGenreFilterChipProps } from "./types";

export function DeviceGenreFilterChip(props: DeviceGenreFilterChipProps) {
  const Comp = isUndefined(props.value)
    ? DeviceGenreAvailableFilterChip
    : DeviceGenreAppliedFilterChip;

  return <Comp {...props} />;
}
